var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconGlutenFreeColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D88A19",
    d: "M18.929 5.298l.833.833L2.619 23.274l-.833-.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A825",
    d: "M22.083 5.893c-1.547 1.547-3.333.952-3.571.774-.298-.298-.774-2.024.655-3.572 1.25-1.31 4.047-1.31 4.047-1.31s0 2.858-1.13 4.108zM11.19 15.357c1.727-.119 3.81.595 4.643 1.19-.654 1.191-1.845 2.024-3.571 2.322-2.322.357-3.393-1.25-3.512-1.667-.119-.357 0-1.666 2.44-1.845zm1.072-1.667c.119.417 1.19 1.965 3.512 1.548 1.726-.298 2.916-1.25 3.571-2.44-1.071-.774-3.035-1.25-4.643-.953-1.666.298-2.56 1.488-2.44 1.845zm5.417-5.297c-1.667.595-1.965 1.31-1.846 1.607.298.774 1.667 1.905 3.69 1.429 1.667-.358 2.798-2.143 2.917-3.274.12-.12-2.559-.536-4.761.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A825",
    d: "M7.798 16.31c-.417-.12-1.965-1.191-1.667-3.512.298-1.727 1.13-2.917 2.321-3.572.596.774 1.25 2.798 1.19 4.643-.237 2.44-1.487 2.56-1.844 2.44zm5.416-5.893c.298-1.667-.178-3.572-1.012-4.643-1.19.655-2.023 1.726-2.44 3.512-.357 2.321 1.19 3.393 1.548 3.512.476.119 1.607-.715 1.904-2.381zm3.988-7.857c-1.19.119-2.916 1.13-3.392 2.916-.596 2.024.535 3.572 1.071 3.87.298.118 1.25-.12 1.905-1.786.774-2.381.416-5 .416-5zM7.56 18.988c1.726-.119 3.809.595 4.642 1.19-.654 1.191-1.845 2.024-3.571 2.322-2.321.357-3.393-1.25-3.512-1.667-.06-.416 0-1.666 2.44-1.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A825",
    d: "M4.167 19.94c-.417-.119-1.965-1.19-1.667-3.511.298-1.727 1.131-2.917 2.321-3.572.596.774 1.25 2.798 1.19 4.643-.178 2.44-1.428 2.56-1.844 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M.336 2.02L2.02.336l22.602 22.602-1.684 1.684z"
  }))));
}

export default SvgCommonIconGlutenFreeColor;